import * as React from "react";

const BinaryData = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <text
        fontFamily="HelveticaNeue-Medium, Helvetica Neue"
        fontSize={6}
        fontWeight={400}
        fill="#7B838C"
      >
        <tspan x={3.328} y={8.25}>
          1010
        </tspan>
      </text>
      <text
        fontFamily="HelveticaNeue-Medium, Helvetica Neue"
        fontSize={6}
        fontWeight={400}
        fill="#7B838C"
      >
        <tspan x={3.328} y={16.25}>
          0101
        </tspan>
      </text>
    </g>
  </svg>
);

export default BinaryData;

